// window.SiteReady(($) => {
window.MapsReady(($) => {

  console.log('Init Block: Map');

  function initMarker($marker, data) {
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let size = $marker.data('size');

    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    let marker = new google.maps.Marker({
      position: latLng,
      map: data.map,
      icon: window.THEME_MAP_MARKER(size),
    });

    data.markers.push(marker);

    let content = $marker.html();

    if (content) {
      let infowindow = new google.maps.InfoWindow({
        content: '<div class="map_infowindow">' + content + '</div>',
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (data.infoWindow) {
          data.infoWindow.close();
        }

        infowindow.open(data.map, marker);
        data.infoWindow = infowindow;
      });
    }
  }

  function centerMap(data) {
    let bounds = new google.maps.LatLngBounds();

    data.markers.forEach((marker) => {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (data.markers.length == 1) {
      data.map.setCenter(bounds.getCenter());
    } else {
      data.map.fitBounds(bounds);
    }
  }

  //

  function initMap($el) {
    let data = {
      $el: $el,
      $map: $el.find('.js-location_finder_map'),
      $markers: $el.find('.js-map_marker'),
      markers: [],
      infoWindow: null,
    };

    let mapOptions = {
      zoom: $el.data('zoom') || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles: window.THEME_MAP_STYLES,
    };

    data.map = new google.maps.Map($el[0], mapOptions);
    data.markers = [];

    data.$markers.each((index, el) => {
      initMarker($(el), data);
    });

    centerMap(data);

    return data;
  }

  //

  $('.js-google_map').each((index, el) => {
    let map = initMap($(el));
  });

});